import type { FC, PropsWithChildren } from 'react';
import React, { useMemo } from 'react';

import type { AppContainerFUI9ThemePrivateContextProviderProps } from './context';
import { AppContainerFUI9ThemePrivateContext } from './context';

export type { AppContainerFUI9ThemePrivateContextProviderProps };

const AppContainerFUI9ThemePrivateContextProvider: FC<
  PropsWithChildren<AppContainerFUI9ThemePrivateContextProviderProps>
> = ({ theme, dir, children }) => {
  const props = useMemo(() => ({ theme, dir }), [theme, dir]);

  return (
    <AppContainerFUI9ThemePrivateContext.Provider value={props}>
      {children}
    </AppContainerFUI9ThemePrivateContext.Provider>
  );
};

export default AppContainerFUI9ThemePrivateContextProvider;
